import './modal.css';

const React = require('react');
const Modal = require('react-modal');

Modal.setAppElement("#root");
// ============================



// ============================
class ModalWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    customStyles() {
        return {
            overlay: {
                zIndex: "100",
                backgroundColor: "rgba(0, 0, 0, 0.5)"
            },
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                padding: "0",
                transform: "translate(-50%, -50%)"
            }
        }
    };
    openModal() {
        this.setState({ modalIsOpen: true })
    }

    afterOpenModal() {
        // modal shown
    }

    closeModal() {
        const { isCloseOutOfArea = false, closeRequest } = this.props;
        if (isCloseOutOfArea) {
            closeRequest();
        }
    }

    renderComponent() {
        const { contents = undefined } = this.props;
        return contents;
    }

    render() {
        const { isModalOpen, closeMs = 200 } = this.props;
        return (
            <Modal
                isOpen={isModalOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={this.customStyles()}
                contentLabel="Common Modal"
                closeTimeoutMS={closeMs}
            >
                <div className="noselect">
                    {this.renderComponent()}
                </div>
            </Modal>
        )
    }
}

export default ModalWindow;